import Blog from "@/Layouts/Blog";
import Hero from "@/Sections/Hero";
import { Head } from "@inertiajs/inertia-react";
import Contact from "@/Sections/Contact";

import { BookOpenIcon, CashIcon, ClockIcon } from "@heroicons/react/solid";

export default function AboutPage() {
    const information = [
        {
            name: "Inhoud: Voeding, Training, Stress, Slaap en Ademhaling",
            icon: BookOpenIcon,
        },
        {
            name: "Duur: 120 minuten",
            icon: ClockIcon,
        },
        {
            name: "Tarief: 299 euro,- ",
            icon: CashIcon,
        },
    ];

    return (
        <Blog>
            <Head>
                <title>
                    Inspirerende lezingen - WE ARE Personal Training Uden en
                    Schijndel
                </title>
                <link
                    rel="canonical"
                    href={route("course.inspiring-lectures")}
                />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Jouw transformatie binnen 12 weken? Bij WE ARE personal training Uden en Schijndel regelen we het! Geen resultaat = geld terug!"
                />
                <meta
                    property="og:description"
                    content="Jouw transformatie binnen 12 weken? Bij WE ARE personal training Uden en Schijndel regelen we het! Geen resultaat = geld terug!"
                />
                <meta
                    property="og:url"
                    content={route("course.inspiring-lectures")}
                />
                <meta property="og:type" content="website" />
                <meta
                    property="og:title"
                    content="Inspirerende lezingen - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/personal-training-uden-schijndel.png"
                />
            </Head>

            <div className="bg-black">
                <Hero homepage={false}></Hero>

                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                    <div className="overflow-hidden">
                        <h2 className="block text-center text-white mx-auto font-custom italic font-bold uppercase max-w-4xl xs:text-4xl sm:text-4xl md:text-4xl lg:text-5xl mt-8">
                            Inspirerende lezingen voor een gezondere leefstijl
                            op de werkvloer
                        </h2>

                        <div className="mx-auto max-w-7xl px-6 lg:px-8 pt-24">
                            <p className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">
                                Investeer in de{" "}
                                <span className="text-we-are-yellow">
                                    vitaliteit
                                </span>{" "}
                                van uw medewerkers
                            </p>
                            <p className="mt-6 text-lg leading-8 text-white">
                                Heeft uw bedrijf behoefte aan een deskundige
                                spreker die uw medewerkers praktische handvatten
                                biedt om hun gezondheid te verbeteren? Dan bent
                                u bij ons aan het juiste adres. Onze passie is
                                het delen van kennis over een gezonde leefstijl,
                                en we streven ernaar zoveel mogelijk mensen
                                hierin mee te nemen.
                            </p>
                            {/*  */}
                            <p className="mt-10 text-3xl font-bold tracking-tight text-white sm:text-4xl">
                                Vijf essentiële domeinen voor{" "}
                                <span className="text-we-are-yellow">
                                    optimale gezondheid
                                </span>
                            </p>
                            <p className="mt-6 text-lg leading-8 text-white">
                                Onze lezingen richten zich op vijf cruciale
                                domeinen die nauw met elkaar verbonden zijn:
                                voeding, training, slaap, stress en ademhaling.
                                Deze aspecten beïnvloeden elkaar voortdurend en
                                vormen samen de basis voor een gezonde
                                leefstijl.
                            </p>
                            {/*  */}
                            <p className="mt-10 text-3xl font-bold tracking-tight text-white sm:text-4xl">
                                Praktische inzichten voor uw medewerkers
                            </p>
                            <p className="mt-6 text-lg leading-8 text-white">
                                Tijdens onze inspirerende lezingen nemen we uw
                                medewerkers mee in een wereld van toegankelijke
                                gezondheidsverbetering. We behandelen onder
                                andere:
                            </p>
                            <ol className="mt-6 text-lg leading-8 text-white list-decimal">
                                <li>
                                    Hoe u eenvoudig meer beweging en training in
                                    uw dagelijks leven kunt integreren, zonder
                                    dat het veel tijd kost
                                </li>
                                <li>
                                    Manieren om gezonde voeding toe te passen
                                    zonder ingewikkelde recepten
                                </li>
                                <li>
                                    Technieken om uw slaapkwaliteit te
                                    verbeteren, zodat u optimaal kunt opladen
                                </li>
                                <li>
                                    Technieken om uw stressniveau te verlagen om
                                    een overprikkeld brein te voorkomen.
                                </li>
                            </ol>
                        </div>
                    </div>

                    <div className="overflow-hidden py-12">
                        <div className="mx-auto max-w-7xl px-6 lg:px-8">
                            <p className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">
                                <span className="text-we-are-yellow">
                                    Voordelen
                                </span>{" "}
                                voor uw organisatie
                            </p>
                            <p className="mt-6 text-lg leading-8 text-white">
                                Door gebruik te maken van onze lezingen voorziet
                                u uw medewerkers van waardevolle kennis over
                                deze belangrijke gezondheidsaspecten. Dit stelt
                                hen in staat hun leefstijl te verbeteren, wat
                                diverse voordelen met zich meebrengt:
                            </p>
                            <ol className="mt-6 text-lg leading-8 text-white list-decimal">
                                <li>Verhoogde productiviteit</li>
                                <li>Verbeterde werksfeer</li>
                                <li>Lager ziekteverzuim</li>
                                <li>
                                    Aanzienlijke kostenbesparing voor uw bedrijf
                                </li>
                            </ol>
                        </div>

                        <div className="mx-auto max-w-7xl px-6 lg:px-8 mt-12 xs:mt-8 sm:mt-8 md:mt-12 lg:mt-12">
                            <p className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">
                                Samen werken aan een{" "}
                                <span className="text-we-are-yellow">
                                    gezondere toekomst
                                </span>
                            </p>
                            <p className="mt-6 text-lg leading-8 text-white">
                                Wilt u samen met uw medewerkers de stap zetten
                                naar een gezondere leefstijl? Laat u dan
                                inspireren door onze deskundige sprekers en geef
                                uw organisatie een boost op het gebied van
                                vitaliteit en welzijn.
                            </p>
                            <p className="mt-6 text-lg leading-8 text-white">
                                Neem vandaag nog contact met ons op om de
                                mogelijkheden te bespreken en uw medewerkers te
                                voorzien van de kennis en motivatie die nodig
                                zijn voor een gezondere en productievere
                                werkomgeving.
                            </p>
                        </div>
                        <div className="mx-auto max-w-7xl px-6 lg:px-8 mt-12 xs:mt-8 sm:mt-8 md:mt-12 lg:mt-12">
                            <dl className="mt-10 max-w-xl space-y-8 text-base leading-7 text-white lg:max-w-none">
                                {information.map((feature) => (
                                    <div
                                        key={feature.name}
                                        className="relative pl-9"
                                    >
                                        <dt className="inline font-semibold text-white">
                                            <feature.icon
                                                aria-hidden="true"
                                                className="absolute left-1 top-1 h-5 w-5 text-we-are-yellow"
                                            />
                                            {feature.name}
                                        </dt>{" "}
                                        <dd className="inline">
                                            {feature.description}
                                        </dd>
                                    </div>
                                ))}
                            </dl>
                        </div>
                    </div>
                </div>

                <Contact />
            </div>
        </Blog>
    );
}
